import { isEmpty } from 'lodash';
import { IPaymentTermResponse, IPaymentTermsTableData } from '.';
import { IListingData } from '@models/listing';

export function mapToListingData(
  data: IPaymentTermResponse[],
  categories: Record<string, string>
): IListingData {
  if (isEmpty(data))
    return {
      pagedItems: {},
      pageSize: 5,
      pageNumber: 0,
      totalCount: 0,
    };

  const finalList: Record<string, IPaymentTermsTableData> = {};

  data?.forEach((obj: IPaymentTermResponse) => {
    const billType = obj.accounting_ParentBill_ParentBillCategory;
    const policyName =
      obj.accounting_ParentBill_PolicyID?.views?.Production_all?.properties
        ?.PolicyNumber;
    const certificateNumber =
      obj.accounting_ParentBill_PolicyID?.views?.Production_all?.properties
        ?.CertificateNumber;
    const policyType = obj.policy_Type;

    finalList[obj.accounting_ParentBill_Id] = {
      id: obj.accounting_ParentBill_Id,
      billType: categories[billType],
      reference:
        billType === 'PRODUCTION'
          ? policyType === 'CERTIFICATE'
            ? `${policyName} ${certificateNumber}`
            : policyName
          : policyType === 'CERTIFICATE'
            ? `${policyName} ${certificateNumber} ${obj.linkedAmendment_AmendmentNumber} ${obj.linkedAmendment_AmendmentLineNumber}`
            : `${policyName} ${obj.linkedAmendment_AmendmentNumber} ${obj.linkedAmendment_AmendmentLineNumber}`,
      totalPremium: obj.accounting_ParentBill_TotalPremium,
      amountReceived: obj.accounting_ParentBill_TotalAmountReceived,
      amountPaid: obj.accounting_ParentBill_TotalAmountPaid,
      amountDue: obj.accounting_ParentBill_TotalAmountDue,
      commission: obj.accounting_ParentBill_TotalCommission,
      taxOnCommission: obj.accounting_ParentBill_TotalTaxOnCommission,
      linkedAmendmentId: obj.linkedAmendment_Id,
      linkedAmendment: obj.linkedAmendment_AmendmentNumber,
      linkedAmendmentEffectiveDate: obj.linkedAmendment_AmendmentEffectiveDate,
      Currency: obj.accounting_ParentBill_Currency?.Symbol,
      viewBreakdown: 'View Breakdown',
      AvailableActions:
        !isNaN(obj.accounting_ParentBill_TotalAmountDue) &&
        Number(obj.accounting_ParentBill_TotalAmountDue) > 0
          ? ['changepaymentterms']
          : [],
    };
  });

  return {
    pagedItems: finalList,
    pageSize: 5,
    pageNumber: 1,
    totalCount: Object.keys(finalList).length,
  };
}
